<style type="text/css">
.footer-images {
    margin: auto;
    display: block;
    bottom: 0;
    text-align: center;
}
.text-small {
    font-size:10px;
}

.mobile-icons-item{
    width: 50%;
    float: left;
}

.mobile-icons-item-solo{
    width: 50%;
    float: left;
}

@media only screen and (max-width: 767px) {
    .location-container{
        min-height: 280px;
    }

    .address-display{
        margin-bottom: 20px;
    }

}

</style>

<template>
    <div>
        <hr v-if="index > 0" class="special-line-no-margin mt-16" />

        <div class="location-box location-container">
            <div class="location mt-16 ">
                <img v-if="loggedUser" :src="'assets/images/' + (searchResult.favorite ? 'favorite.png' : 'not_favorite.png')" style="cursor:pointer" width="24px" align="left" class="mr-1" v-on:click="changeFavoriteStatusValue"/>
                <div class="location box">
                    <router-link class="text-decoration-none" v-if="searchResult.idMedico !== null" :to="{name: 'HospitalMedico', params: { id: searchResult.idAcordoMorada, medico: searchResult.idMedico, filtroEsp: filtroEspecialidade, from: origin  }}">
                        <h5 class="custom-h5 secondary-color">{{ searchResult.nomeComercial !== null ? searchResult.nomeComercial : searchResult.entidade }}</h5>
                        <h6 class="custom-h5 secondary-color text-decoration-none" v-if="searchResult.medico !== null && searchResult.entidade !== null">{{ searchResult.tituloMedico }} {{ searchResult.medico }}</h6>
                    </router-link>
                    <router-link class="text-decoration-none" v-else :to="{name: 'Hospital', params: { id: searchResult.idAcordoMorada, filtroEsp: filtroEspecialidade, from: origin }}">
                        <h5 class="custom-h5 secondary-color">{{ searchResult.nomeComercial !== null ? searchResult.nomeComercial : searchResult.entidade }}</h5>
                    </router-link>
                </div>
            </div>
            <div class="location mt-24 ">
                <img src="assets/images/location_blue.png" class="mr-1" />
                <div class="location box">
                    <a class="custom-p block sm primary-color text-decoration-none" target="_new"
                       :href="'https://www.google.com/maps/dir/?api=1&origin=' + userCurrentLocation + '&destination=' + encodedMorada">
                        {{ searchResult.morada }}<br/>
                        {{ searchResult.cp4 }}-{{ searchResult.cp3 }} {{ searchResult.localidade }}<br/>
                    </a>
                </div>

                <div class="btn-hide" style="height: 25px">
                    <img src="assets/images/gray_shield.png" class="location icons" v-on:mouseover="hoverSams = !hoverSams" v-on:mouseout="hoverSams = !hoverSams" />
                    <span class="location text" >SNQTB Saúde</span>
                    <img src="assets/images/gray_heart.png" class="location icons"  v-if="searchResult.cartaoFamilia" v-on:mouseover="hoverFamilia = !hoverFamilia" v-on:mouseout="hoverFamilia = !hoverFamilia" />
                    <span class="location text" v-if="searchResult.cartaoFamilia">Plano Saúde SNQTB</span>
                </div>

            </div>

            <div class="location mt-24 address-display">
                <img src="assets/images/blue_phone.png" class="mr-1" />
                <div class="location box">
              <span class="custom-p block sm primary-color text-decoration-none">
                  {{ searchResult.telefone === null ? "&nbsp;" : searchResult.telefone }}
              </span>
                </div>
            </div>

            <div class="btn-hide-mobile">
                <div class="text-center" :class="{'mobile-icons-item-solo': searchResult.cartaoFamilia, 'mobile-icons-item': searchResult.cartaoFamilia }">
                    <img src="assets/images/gray_shield.png"/>
                    <p>SNQTB Saúde</p>
                </div>
                <div class="text-center mobile-icons-item" v-if="searchResult.cartaoFamilia">
                    <img src="assets/images/gray_heart.png"/>
                    <p >Plano Saúde SNQTB</p>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    props: ['index', 'searchResult', 'filtroEspecialidade', 'origin' ],

    data() {
        return {
            hoverSams: false,
            hoverFamilia: false,
            myLocation: 'My+Location',
        };
    },
    computed: {
        ...mapGetters('dirpesquisador',
            {
                userCurrentLocation: 'getUserCurrentLocation',
                loggedUser: 'getLoggedUser',
                loggedToken: 'getLoggedToken'
            },
        ),
        encodedMorada() {
            const searchResult = this.searchResult;
            return encodeURI(searchResult.morada + ' ' + searchResult.cp4 + '-' + searchResult.cp3 + ' ' + searchResult.localidade);
        }
    },
    methods: {
        ...mapActions('dirpesquisador',
            {
                changeFavoriteStatus: 'changeFavoriteStatus',
            },
        ),
        changeFavoriteStatusValue() {
            const self = this;
            parent.postMessage('loadinghide','*');

            this.changeFavoriteStatus(
                {
                    idAcordoMorada: this.searchResult.idAcordoMorada,
                    idMedico: this.searchResult.idMedico,
                    favorito: !this.searchResult.favorite,
                    user: this.loggedUser,
                    token: this.loggedToken,
                },
            )
                .then((response) => {
                    if (response)
                        self.searchResult.favorite = !self.searchResult.favorite;
                    parent.postMessage('loadinghide','*');
                })
                .catch(() => {
                    console.log('Error changeFavoriteStatus!');
                    parent.postMessage('loadinghide','*');
                });
        },
    }
};
</script>
